import { render, staticRenderFns } from "./BreadcrumbNavigation.vue?vue&type=template&id=8adc210c&scoped=true&"
import script from "./BreadcrumbNavigation.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbNavigation.vue?vue&type=script&lang=js&"
import style0 from "./BreadcrumbNavigation.vue?vue&type=style&index=0&id=8adc210c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8adc210c",
  null
  
)

export default component.exports